import React, { useContext } from 'react'
import Workflow from './Workflow'
import { useInvitationDetails } from '../hooks'
import { userService } from '../services'
import { initialization, conversion } from '../core'
import { AppContext } from '../contexts/AppContext'
import { Redirect } from 'react-router'
import { AppLoading } from '../pages'
import helpers from '../util/helpers'

const AcceptInvitationWorkflow: React.FC = () => {
  const { state, dispatch } = useContext(AppContext)
  const { id, token, details, loading } = useInvitationDetails()

  if (state.isAuthenticated) {
    return <Redirect to="/a/dashboard/" />
  }

  if (loading) {
    return <AppLoading />
  }

  const complete = (data: any) =>
    helpers.withLoading(async () => {
      console.log({ token, ...data })
      await userService.acceptInvitation(id, { token, ...data })
      await initialization.onAuthenticated(dispatch)
      conversion.trackRegistration()
    })

  return (
    <Workflow
      id="accept-invite"
      steps={[
        {
          id: 'credentials',
          fields: [
            {
              key: 'email',
              type: 'input',
              inputType: 'email',
              label: 'Email',
              required: true,
            },
            {
              key: 'username',
              type: 'input',
              label: 'Username',
              required: true,
            },
            {
              key: 'password',
              type: 'input',
              label: 'Password',
              inputType: 'password',
              required: true,
            },
          ],
          footnote:
            'By signing up you agree to our privacy policy and our terms of conditions.',
          button: {
            children: 'Finish',
          },
          title: 'Welcome!',
          subtext:
            'Choose a username and password. This will be yours to keep, even if you switch programs in the future.',
        },
      ]}
      data={{
        username: details?.usernames?.shift() ?? '',
        email:
          details?.invite?.sendType === 'EMAIL'
            ? details?.invite?.recipient
            : '',
      }}
      onComplete={complete}
      required
    />
  )
}

export default React.memo(AcceptInvitationWorkflow)
